import firebase from 'gatsby-plugin-firebase';
import { reject } from 'lodash';
import { joinDateToNumberString } from '../utils/helperFunctions';

export const checkUpdatePosts = async (curNumPosts, posts) => {
  const numPosts = await (await firebase.firestore().collection('posts').get())
    .size;
  if (numPosts !== curNumPosts) {
    updatePosts(posts);
  }
};

export const updatePosts = (posts) => {
  return new Promise(async (resolve, reject) => {
    try {
      for (let post of posts) {
        const postSnap = await firebase
          .firestore()
          .doc(`posts/${post.contentful_id}`)
          .get();
        if (!postSnap.exists) {
          await firebase
            .firestore()
            .doc(`posts/${post.contentful_id}`)
            .set({ ...post, views: {}, totalViews: 0 });
        } else {
          await firebase
            .firestore()
            .doc(`posts/${post.contentful_id}`)
            .update({ ...post });
        }
      }
      console.log('updated');
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

export const increasePostView = async (postId) => {
  try {
    const postSnap = await firebase.firestore().doc(`posts/${postId}`).get();
    if (!postSnap.exists) reject(new Error("Post doesn't exist"));
    const { views } = postSnap.data();
    const today = joinDateToNumberString(new Date());
    views[today] = views[today] ? views[today] + 1 : 1;
    const totalViews = Object.values(views).reduce(
      (item, acc) => acc + item,
      0
    );
    await firebase
      .firestore()
      .doc(`posts/${postId}`)
      .update({ views, totalViews });
  } catch (error) {
    reject(error);
  }
};

export const getPostViews = async (postId) => {
  try {
    const postSnap = await firebase.firestore().doc(`posts/${postId}`).get();
    if (!postSnap.exists) reject(new Error('Post not found'));
    const { views } = postSnap.data();
    const countViews = Object.values(views).reduce(
      (item, acc) => acc + item,
      0
    );
    return countViews;
  } catch (error) {
    reject(error);
  }
};

export const getMostViewsPosts = async (numPosts = 7) => {
  return new Promise(async (resolve, reject) => {
    try {
      const postsSnap = await firebase
        .firestore()
        .collection('posts')
        .orderBy('totalViews', 'desc')
        .limit(numPosts)
        .get();
      const posts = postsSnap.docs.map((post) => ({
        id: post.id,
        ...post.data(),
      }));
      return resolve(posts);
    } catch (error) {
      reject(error);
    }
  });
};

export const fetchPosts = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const postsSnap = await firebase.firestore().collection('posts').get();
      const posts = postsSnap.docs.map((post) => ({
        id: post.id,
        ...post.data(),
      }));

      resolve(posts);
    } catch (error) {
      reject(error);
    }
  });
};
